/** @jsx jsx */
import { memo } from 'react';
import { css, jsx } from '@emotion/react';
import Button from '@atlaskit/button/standard-button';
import __noop from '@atlaskit/ds-lib/noop';
import { fontSize, gridSize } from '@atlaskit/theme/constants';
var height = gridSize() * 3 / fontSize();
var noop = __noop;
var gridSizeUnit = gridSize();
var itemWrapperStyles = css({
  display: 'flex',
  boxSizing: 'border-box',
  maxWidth: '100%',
  height: "".concat(height, "em"),
  margin: 0,
  padding: 0,
  flexDirection: 'row',
  lineHeight: "".concat(height, "em"),
  '&:not(:last-child)::after': {
    width: "".concat(gridSizeUnit, "px"),
    padding: "0 ".concat(gridSizeUnit, "px"),
    flexShrink: 0,
    content: '"/"',
    textAlign: 'center'
  }
});
var EllipsisItem = /*#__PURE__*/memo(function (props) {
  var _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? noop : _props$onClick,
      testId = props.testId,
      label = props.label;
  return jsx("li", {
    css: itemWrapperStyles
  }, jsx(Button, {
    appearance: "subtle-link",
    spacing: "none",
    testId: testId,
    onClick: onClick,
    "aria-label": label
  }, "\u2026"));
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc

export default EllipsisItem;